import { computed, type ComputedRef, ref, type Ref } from 'vue'

type ArraySource<T> = Ref<T[]> | ComputedRef<T[]> | T[]

export function useSearch<T>(
  source: ArraySource<T>,
  options?: {
    toSearchString?: (item: T) => string
  }
) {
  const searchTerm = ref('')
  const toSearchString =
    options?.toSearchString ?? ((item: T) => JSON.stringify(item).toLowerCase())

  const sourceItems = computed<T[]>(() => {
    if (Array.isArray(source)) return source
    return source.value
  })

  const searchList = computed(() =>
    sourceItems.value.map(item => ({
      original: item,
      flat: toSearchString(item),
    }))
  )

  const filteredItems = computed<T[]>(() => {
    if (!searchTerm.value.trim().toLowerCase()) return sourceItems.value

    return searchList.value
      .filter(value => value.flat.includes(searchTerm.value.trim().toLowerCase()))
      .map(value => value.original)
  })

  return {
    filteredItems,
    searchTerm,
    searchList,
  }
}
